module.exports = __webpack_public_path__ + "media/images/icon/ranking/third-6e06b62df2f7520448fcab10d0838026.png";